import { useEffect } from "react";

const FinanceClient = () => {
  useEffect(() => {
    document.title = "Финансы | В разработке";
  }, []);
  return null;
};

export default FinanceClient;
